<header>
  <div class="logo">
    <img src="assets/logo-light.png" alt="Immobile" />
  </div>
</header>

<div class="buttons" *ngIf="platform.IOS || platform.ANDROID">
  <a
    class="btn-store"
    *ngIf="platform.IOS"
    target="_blank"
    href="https://apps.apple.com/br/app/immobile/id1568336449"
    rel="noreferrer"
  >
    <i class="fab fa-apple"></i>
    <span>Baixar na App Store</span>
  </a>
  <a
    class="btn-store"
    *ngIf="platform.ANDROID"
    target="_blank"
    href="https://play.google.com/store/apps/details?id=digital.yourway.immobile"
    rel="noreferrer"
  >
    <i class="fab fa-android"></i>
    <span>Baixar na Play Store</span>
  </a>
</div>

<section class="loading-container" [class.active]="isLoading">
  <mat-spinner [diameter]="64"></mat-spinner>
</section>

<section class="content">
  <div class="container container-small">
    <div class="header">
      <div class="header-wrapper">
        <div class="col">
          <h1 class="title">
            {{ empreendimento.nome }}
          </h1>
          <p>
            {{ empreendimento.cep | mask: "00000-000" }} -
            {{ empreendimento.bairro }} - {{ empreendimento.endereco }},
            {{ empreendimento.enderecoNumero }}
            {{ empreendimento.complemento }} - {{ empreendimento.cidade }} -
            {{ empreendimento.uf }}
          </p>
        </div>
        <div class="col hidden-mobile">
          <a class="btn-link" (click)="openSharedDialog()">
            <i class="fas fa-share"></i>
            <span>Compartilhar</span>
          </a>
        </div>
      </div>
    </div>
    <div class="gallery" id="fancyBox">
      <div class="gallery-wrapper">
        <div class="col">
          <div
            class="gallery-item gallery-item--large"
            (click)="openFancyBox(0)"
          >
            <img
              [src]="global.imageUrl + gallery.main.imagem"
              [alt]="gallery.main.nome"
            />
          </div>
        </div>
        <div class="col hidden-desktop">
          <div
            class="gallery-item gallery-item--large"
            (click)="openFancyBox(0)"
          >
            <img
              [src]="global.imageUrl + gallery.total[1]?.imagem"
              [alt]="gallery.total[1]?.nome"
            />
          </div>
        </div>
        <div class="col hidden-mobile">
          <div
            class="gallery-item gallery-item--large"
            *ngIf="gallery.grid.length < 4"
            (click)="openFancyBox(1)"
          >
            <img
              [src]="global.imageUrl + gallery.total[1].imagem"
              [alt]="gallery.total[1].nome"
            />
          </div>
          <div class="gallery-grid" *ngIf="gallery.grid.length === 4">
            <div
              class="gallery-item"
              *ngFor="let item of gallery.grid; let i = index"
              (click)="openFancyBox(i + 1)"
            >
              <img [src]="global.imageUrl + item.imagem" [alt]="item.nome" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main">
      <div class="wrapper">
        <div class="large-content">
          <div class="info">
            <div class="info-wrapper">
              <div class="info-item">
                <img src="assets/icons/reduce.png" alt="reduce" />
                <span>{{ empreendimento.tamanhoAreaConstruidaM2 }} m²</span>
              </div>
              <div class="info-item">
                <img src="assets/icons/bed.png" alt="reduce" />
                <span>{{ empreendimento.numeroQuartos }}</span>
              </div>
              <div class="info-item">
                <img src="assets/icons/sink.png" alt="reduce" />
                <span>{{ empreendimento.numeroBanheiros }}</span>
              </div>
              <div class="info-item">
                <img src="assets/icons/car.png" alt="reduce" />
                <span>{{ empreendimento.numeroBoxGaragem }}</span>
              </div>
            </div>
          </div>
          <div class="main-description">
            <p>{{ empreendimento.descricao }}</p>
          </div>
          <ul>
            <li *ngFor="let item of infos">
              <span>{{ item.label }}</span>
              <strong>{{ item.value }}</strong>
            </li>
          </ul>
        </div>
        <div class="box">
          <h2>
            <span>Valor</span>
            {{ empreendimento.valor | currency: "BRL" }}
            <small *ngIf="empreendimento.tipoOferta === 'L'">/ mensal</small>
          </h2>
          <button
            class="btn btn-secondary btn-block dark"
            (click)="openContactDialog()"
          >
            <span>Entrar em contato</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<button class="float-button hidden-desktop" (click)="openSharedDialog()">
  <i class="fas fa-share"></i>
</button>
